// Get the div#ssw-avg-rate-profile-html
var avgRateProfileHtml = document.getElementById('ssw-avg-rate-profile-html');

// Get the form element
//const form = document.querySelector('.product-details');

// Get the first element with the specified class within the form
//const firstProductDetails = form.querySelector('.product-details__app.custom-product-details');

// Display the content of the first element (for demonstration purposes)
//console.log(firstProductDetails.textContent);


// Get the .mobile-product-title-section
var mobileProductTitleSection = document.querySelector('.mobile-product-title-section');

// Append the div#ssw-avg-rate-profile-html inside .mobile-product-title-section
// mobileProductTitleSection.appendChild(avgRateProfileHtml);


document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.querySelector && node.querySelector('.quantity-field')) {
          console.log('Modal opened, .quantity-field detected!');
          // Now add event listener for input
          const quantityField = node.querySelector('.quantity-field');
          if (quantityField) {
            quantityField.addEventListener('input', function(event) {
              var quantity = event.target.value;
              var pid = quantityField.getAttribute('data-product-id');
              const quantityEl = document.querySelector(`[data-product-count="${pid}"]`);
              if (quantityEl) quantityEl.value = quantity;
            });
          }
        }
      });
    });
  });

  // Start observing changes to the body element
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
